module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#online-news",
      toString: function () {
        return this.url;
      }
    }